import React from 'react';
import { Modal, Row, Col, ButtonToolbar, Button } from 'react-bootstrap';
import messages from './messages';
import { FormattedMessage } from 'react-intl';
import SubmitButton from '../../../components/SubmitButton';

type Props = {
  onHide: Function,
  onSubmit: Function,
  show: boolean,
  isDeletePaymentBatchLoading: boolean,
};

const ConfirmDeleteSubsidyBatch = (props: Props) => {
  const { onHide, onSubmit, show, isDeletePaymentBatchLoading } = props;
  return (
    <div className="static-modal">
      <Modal
        bsSize="small"
        dialogClassName="modal-dialog modal-alert"
        show={show}
        onHide={onHide}
        autoFocus={true}
      >
        <Modal.Body>
          <Row>
            <Col xs={12}>
              <h2 className="text-center">
                <FormattedMessage {...messages.confirmDeleteMessageTitle} />
              </h2>
              <p className="text-center">
                <FormattedMessage {...messages.confirmDeleteNote} />
              </p>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <ButtonToolbar>
            <Button type="button" bsStyle="default" onClick={onHide}>
              <FormattedMessage {...messages.no} />
            </Button>
            <SubmitButton
              type="submit"
              bsStyle="primary"
              classes="pull-left"
              clickHandler={() => {
                onSubmit();
              }}
              isSubmitting={isDeletePaymentBatchLoading}
            >
              <FormattedMessage {...messages.yes} />
            </SubmitButton>
          </ButtonToolbar>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ConfirmDeleteSubsidyBatch;
